import React from 'react';

import { Table } from './pieces/table';

export default function AxisLocking(): React.JSX.Element {
	return <Table />;
}
